<template>
  <div>
    <!-- <Loader/> -->
    <div class="wrapper">

      <SidebarStyle/>
      <HeaderStyle1/>
      <!-- 진단 로그 수집 중일 때만 보인다. 숨기고 수집하지 않는다 -->
      <div v-if="diagOn" style="background:#fff3cd;color:#664d03;border-bottom:1px solid #ffe69c;padding:8px 16px;font-size:13px;text-align:center;">
        문제 확인을 위해 <b>진단 로그를 수집하고 있습니다.</b> 입력하신 비밀번호·로그인 정보는 수집되지 않습니다.
      </div>
      <div class="content-page">
        <!-- 쿠패스(COUPLUS WEIHAI) 사이드바 메뉴일 때만 상단 탭 바 + 탭별 화면 보관(2026-10-04 YZY).
             판정은 라우트 이름 한 곳(coupassMenu.js isCoupassTabRoute). 쿠패스 메뉴를 한 번도 안 연 세션(셀러)은 이 부품 자체가 안 생긴다. -->
        <CoupassTabsView v-if="coupassTabsUsed" v-show="isCoupassTab" :active="isCoupassTab"/>
        <transition name="router-anim">
          <!-- 탭 전환 시 상태를 유지할 화면만 화이트리스트로 지정한다.
               여기 없는 화면은 지금까지와 동일하게 매번 새로 뜬다.
               대상 화면은 반드시 activated/deactivated에서 확장 메시지 리스너를 붙였다 떼야 한다. -->
          <keep-alive :include="cachedViews" :max="3">
            <router-view v-if="!isCoupassTab"/>
          </keep-alive>
        </transition>
      </div>
    </div>
    <FooterStyle />
  </div>
</template>
<script>
// import Loader from '@/components/loader/Loader'
import SidebarStyle from "@/components/partials/backend/SidebarStyle/SidebarStyle";
import HeaderStyle1 from "@/components/partials/backend/HeaderStyle/HeaderStyle1";
import FooterStyle from "@/components/partials/backend/FooterStyle/FooterStyle";
import CoupassTabsView from "@/components/partials/backend/CoupassTabs/CoupassTabsView";
import { isCoupassTabRoute } from "@/views/backend/Logis/coupassMenu";
import { scriptsOfHtml, scriptsOfDocument, isNewVersion, versionNoticeText } from "@/utils/versionWatch";
import { tabBusyReasons, shouldAutoReload } from "@/utils/autoUpdate";
import axios from "axios";
export default {
  name: 'Layout-2',
  components: {
    HeaderStyle1,
    FooterStyle,
    SidebarStyle,
    CoupassTabsView,
    // Loader
  },
  data() {
    return {
      sseRetryCount: 0,
      sseMaxRetry: 3,
      // 진단 로그 (상담 중에만 켜진다)
      diagOn: false,
      diagUntil: 0,
      diagBuf: [],
      diagTimer: null,
      diagSending: false,
      diagInCapture: false,
      diagOrigConsole: null,
      // 컴포넌트 name 기준으로 매칭된다. 이름이 겹치는 화면을 넣으면
      // 관계없는 화면까지 캐시되므로, 이름이 고유한 것만 올린다.
      cachedViews: ['GrowthSalesLedger', 'GrowthDb', 'GrowthScmV0'],
      // 쿠패스 탭 화면을 이 세션에서 한 번이라도 열었나 — 그 뒤로는 셀러 화면에 가도 탭·보관 화면을 유지한다
      coupassTabsUsed: isCoupassTabRoute(this.$route.name),
    }
  },
  computed: {
    isCoupassTab() {
      return isCoupassTabRoute(this.$route.name);
    }
  },
  watch: {
    // 라우트 변경을 감지하여 대시보드일 때만 다크테마 적용
    '$route'() {
      this.updateTheme();
      if (this.isCoupassTab) this.coupassTabsUsed = true;
    },
    // 로그인 상태 변경 감지
    '$store.state.user'(newUser) {
      if (newUser && newUser._id) {
        // 로그인됨 - SSE 연결
        this.connectSSE();
      } else {
        // 로그아웃됨 - SSE 해제
        this.disconnectSSE();
      }
    }
  },
  mounted(){
    this.startVersionWatch(); // 새 화면 코드가 배포되면 새로고침 안내(2026-10-16)
    document.body.classList=''
    this.updateTheme();
    // 로그인 상태 확인 후 SSE 연결 (약간의 딜레이)
    setTimeout(() => {
      if (this.$store.state.user && this.$store.state.user._id) {
        this.connectSSE();
        // SSE 는 켜는 순간을 즉시 알려주지만, 이미 켜져 있는 세션은 못 알려준다
        // (담당자가 켠 뒤에 사용자가 화면을 여는 경우). 그래서 진입 때 한 번 물어본다.
        this.diagCheckOnce();
      }
    }, 1000);
  },
  destroyed () {
    document.body.classList=''
    clearInterval(this._verTimer);
    if (this._onUserInput) {
      window.removeEventListener('keydown', this._onUserInput, true);
      window.removeEventListener('pointerdown', this._onUserInput, true);
      document.removeEventListener('visibilitychange', this.applyNewVersion);
    }
    this.disconnectSSE(); // SSE 연결 해제
  },
  methods: {
    // 새 버전 안내 — 이 탭이 열린 뒤에 화면 코드가 새로 배포되면(index.html 의 스크립트 이름이 바뀜) «새로고침» 안내를 띄운다.
    // 오래 열어 둔 탭이 새 기능(알림 등)을 못 받던 문제 대응. 5분마다 확인, 실패는 조용히 넘긴다(다음 주기에 다시)
    startVersionWatch() {
      // 비교 꼴은 utils/versionWatch.js 한 곳 — 탭·index.html 둘 다 <script src> 만·중복 0(10-19 헛 알림 고침)
      const current = scriptsOfDocument(document.scripts, location.origin);
      if (!current) return;
      // 바쁨 문(판 #308) — 쓰던 입력을 안 날리게 마지막 입력 시각을 잰다
      this._lastInputAt = Date.now();
      this._onUserInput = () => { this._lastInputAt = Date.now(); };
      window.addEventListener('keydown', this._onUserInput, true);
      window.addEventListener('pointerdown', this._onUserInput, true);
      document.addEventListener('visibilitychange', this.applyNewVersion);
      this._verTimer = setInterval(async () => {
        try {
          const res = await fetch('/index.html?_=' + Date.now(), { cache: 'no-store' });
          if (!res.ok) return;
          const now = scriptsOfHtml(await res.text());
          if (isNewVersion(current, now)) this._newVersion = true;
          this.applyNewVersion();
        } catch (e) {
          console.error('[version-watch] 확인 실패(다음 주기에 다시):', e.message);
        }
      }, 5 * 60 * 1000);
    },
    // 새 판이 나왔으면 — 받기·작업 0 이고 (탭 숨김 또는 입력 없음 10분)이면 스스로 새로고침, 아니면 안내만 두고 다음 주기·탭 숨김 때 다시 본다
    applyNewVersion() {
      if (!this._newVersion) return;
      const reload = shouldAutoReload({
        tabReasons: tabBusyReasons(this.$store.state),
        hidden: document.visibilityState === 'hidden',
        idleMs: Date.now() - this._lastInputAt,
      });
      if (reload) {
        window.location.reload();
        return;
      }
      if (!this._verNotified) {
        this._verNotified = true;
        const text = versionNoticeText(isCoupassTabRoute(this.$route && this.$route.name));
        this.$bvToast.toast(text.body, {
          id: 'new-version', title: text.title, variant: 'info', solid: true, noAutoHide: true, toaster: 'b-toaster-bottom-right',
          href: '#'
        });
        setTimeout(() => {
          const el = document.getElementById('new-version');
          if (el) el.addEventListener('click', (ev) => { ev.preventDefault(); window.location.reload(); });
        }, 300);
      }
    },
    updateTheme() {
      // 대시보드 페이지인지 확인
      const isDashboard = this.$route.name === 'layout.dashboard1';

      if (isDashboard) {
        // 대시보드일 때 다크테마 적용
        document.body.classList.add('dark');
      } else {
        // 대시보드가 아닐 때 다크테마 제거
        document.body.classList.remove('dark');
      }
    },
    // SSE 전역 연결
    connectSSE() {
      if (typeof EventSource === 'undefined') {
        console.warn('[SSE] 브라우저가 SSE를 지원하지 않습니다.');
        return;
      }

      // 로그인 상태 확인
      if (!this.$store.state.user || !this.$store.state.user._id) {
        console.log('[SSE] 로그인 상태가 아니므로 연결하지 않습니다.');
        return;
      }

      // 이미 연결되어 있으면 스킵
      if (this.$store.state.sseConnection) {
        console.log('[SSE] 이미 연결되어 있습니다.');
        return;
      }

      try {
        console.log('[SSE] 연결 시도 중...');
        const sseConnection = new EventSource('/api/sse/subscribe', { withCredentials: true });
        this.$store.commit('sseSetConnection', sseConnection);

        sseConnection.addEventListener('connected', (event) => {
          console.log('[SSE] 전역 연결됨:', JSON.parse(event.data));
          this.sseRetryCount = 0; // 연결 성공 시 재시도 카운트 초기화
        });

        sseConnection.addEventListener('heartbeat', () => {
          // heartbeat는 연결 유지용
        });

        // 견적서 생성 알림 (고객용)
        sseConnection.addEventListener('quotation_created', (event) => {
          console.log('[SSE] 견적서 생성 알림:', JSON.parse(event.data));
          this.$store.commit('sseIncrementNotification', 'quotation_created');
          this.$bvToast.toast('새로운 견적서가 생성되었습니다.', {
            title: '견적서 알림',
            variant: 'info',
            solid: true
          });
        });

        // 待客户确认 의 «客户回复处理方式» 저장 알림 — 作业人(그 건을 待客户确认 으로 보낸 직원)에게만 온다(2026-10-16 SYL #38). 닫을 때까지 떠 있는다
        sseConnection.addEventListener('confirm_reply', (event) => {
          let d = {};
          try { d = JSON.parse(event.data); } catch (e) { console.error('[SSE] confirm_reply 해석 실패:', e); return; }
          this.$store.commit('sseIncrementNotification', 'confirm_reply');
          const h = this.$createElement;
          const toastId = 'confirm-reply-' + (d._id || Date.now());
          const go = () => {
            this.$router.push({ name: 'logis.logisinboundconfirm', query: { focus: d._id } }).catch(() => {});
            this.$bvToast.hide(toastId);
          };
          // 내용 = 고객명 + 고객과 확인해야 할 내용 + «고객이 이미 회신함». 본문을 누르면 待客户确认 화면의 그 건으로 이동(2026-10-16 SYL #38)
          // 클릭 핸들러는 본문 요소에 직접 건다(토스트 바깥 요소를 id 로 찾는 방식은 렌더 시점에 따라 못 찾았다)
          this.$bvToast.toast(h('div', { style: 'cursor:pointer', on: { click: go } }, [
            h('div', { class: 'font-weight-bold' }, '客户: ' + (d.화주 || '-')),
            h('div', { class: 'small text-muted' }, (d.상품명 || '') + (d.바코드 ? ' · ' + d.바코드 : '')),
            h('div', { class: 'mt-1' }, [h('span', { class: 'small text-muted' }, '需跟客户确认(확인할 내용): '), h('span', { style: 'white-space:pre-wrap' }, d.확인내용중문 || d.확인내용 || '-')]),
            h('div', { class: 'mt-1' }, [h('span', { class: 'small text-muted' }, '客户回复(고객 회신): '), h('span', { style: 'white-space:pre-wrap' }, d.회신 || '(空)')]),
            h('div', { class: 'small text-muted mt-1' }, '处理人 ' + (d.처리인 || '-') + (d.처리인코드 ? '(' + d.처리인코드 + ')' : '') + ' · 点击查看(클릭하면 해당 건으로 이동)')
          ]), {
            id: toastId,
            title: '客户已回复(고객이 이미 회신함)',
            variant: 'warning',
            solid: true,
            noAutoHide: true,
            toaster: 'b-toaster-top-right'
          });
        });

        // 代办列表 — 办公室处理进度에 «仓储 확인 필요» 항목이 들어가면 그 건을 등록한 직원(创建人)에게(2026-10-16 SYL #54)
        sseConnection.addEventListener('daiban_store_confirm', (event) => {
          let d = {};
          try { d = JSON.parse(event.data); } catch (e) { console.error('[SSE] daiban_store_confirm 해석 실패:', e); return; }
          const h = this.$createElement;
          const toastId = 'daiban-store-' + (d._id || Date.now());
          const go = () => {
            this.$router.push({ name: 'logis.logisimporterrorlist', query: { focus: d._id } }).catch(() => {});
            this.$bvToast.hide(toastId);
          };
          this.$bvToast.toast(h('div', { style: 'cursor:pointer', on: { click: go } }, [
            h('div', { class: 'font-weight-bold' }, '订单号 ' + (d.주문번호 || '-') + ' · 客户 ' + (d.화주 || '-')),
            h('div', { class: 'mt-1' }, '有仓储待确认事项，请尽快确认'),
            h('div', { class: 'small text-muted mt-1' }, (d.진도 || '') + ' · 点击查看(클릭하면 해당 대办 상세로 이동)')
          ]), { id: toastId, title: '仓储待确认(창고 확인 필요)', variant: 'warning', solid: true, noAutoHide: true, toaster: 'b-toaster-top-right' });
        });

        // 가격수정 알림 (쿠패스용)
        sseConnection.addEventListener('price_modified', (event) => {
          console.log('[SSE] 가격수정 알림:', JSON.parse(event.data));
          this.$store.commit('sseIncrementNotification', 'price_modified');
          this.$bvToast.toast('판매자가 가격을 수정했습니다. 확인해주세요.', {
            title: '가격수정 알림',
            variant: 'warning',
            solid: true
          });
        });

        // 입금완료 알림 (쿠패스용)
        sseConnection.addEventListener('payment_completed', (event) => {
          console.log('[SSE] 입금완료 알림:', JSON.parse(event.data));
          this.$store.commit('sseIncrementNotification', 'payment_completed');
          this.$bvToast.toast('고객이 입금완료 처리를 했습니다.', {
            title: '입금완료 알림',
            variant: 'success',
            solid: true
          });
        });

        // 출고요청 알림 (쿠패스용)
        sseConnection.addEventListener('shipment_requested', (event) => {
          const data = JSON.parse(event.data);
          console.log('[SSE] 출고요청 알림:', data);
          this.$store.commit('sseIncrementNotification', 'shipment_requested');
          this.$bvToast.toast(`화주(${data.companyid})가 ${data.count}건의 출고요청을 했습니다.`, {
            title: '출고요청 알림',
            variant: 'warning',
            solid: true
          });
        });

        // 물류비 입금요청 알림 (화주용)
        sseConnection.addEventListener('logistics_payment_requested', (event) => {
          const data = JSON.parse(event.data);
          console.log('[SSE] 물류비 입금요청 알림:', data);
          this.$store.commit('sseIncrementNotification', 'logistics_payment_requested');
          this.$bvToast.toast(`${data.type} ${data.count}건의 입금요청이 도착했습니다.`, {
            title: '물류비 입금요청',
            variant: 'warning',
            solid: true
          });
        });

        // 물류비 입금완료 알림 (쿠패스용)
        sseConnection.addEventListener('logistics_payment_completed', (event) => {
          const data = JSON.parse(event.data);
          console.log('[SSE] 물류비 입금완료 알림:', data);
          this.$store.commit('sseIncrementNotification', 'logistics_payment_completed');
          this.$bvToast.toast(`화주(${data.companyid})가 ${data.type} ${data.count}건의 입금완료 처리를 했습니다.`, {
            title: '물류비 입금완료',
            variant: 'success',
            solid: true
          });
        });

        // 진단 로그 켜짐/꺼짐. 상담 중에 담당자가 켜고, 끝나면 끈다.
        // 확장은 SSE 를 직접 구독하지 않으므로(MV3 service worker 가 아이들에 죽는다)
        // 여기서 받아 content script 로 넘겨준다.
        sseConnection.addEventListener('diag_on', (event) => {
          const data = JSON.parse(event.data);
          this.startDiagLog(data.until);
        });
        sseConnection.addEventListener('diag_off', () => {
          this.stopDiagLog();
        });

        sseConnection.onerror = (error) => {
          console.error('[SSE] 연결 오류:', error);
          this.disconnectSSE();

          // 재시도 횟수 제한
          if (this.sseRetryCount < this.sseMaxRetry) {
            this.sseRetryCount++;
            console.log(`[SSE] ${this.sseRetryCount}/${this.sseMaxRetry} 재연결 시도 예정 (10초 후)`);
            setTimeout(() => {
              if (this.$store.state.user && this.$store.state.user._id) {
                this.connectSSE();
              }
            }, 10000);
          } else {
            console.warn('[SSE] 최대 재시도 횟수 초과. 연결 중단.');
          }
        };
      } catch (error) {
        console.error('[SSE] 연결 실패:', error);
      }
    },
    // 이미 켜져 있는 세션을 진입 시 한 번 확인한다. 서버 DB 에 직접 켜둔 경우도 이 길로 잡힌다
    async diagCheckOnce() {
      try {
        const res = await axios.post('/api/diag/status', {
          companyid: this.$store.state.user.companyid,
          suppliercode: this.$store.state.user.suppliercode
        });
        if (res.data && res.data.on) this.startDiagLog(res.data.until);
      } catch (e) {
        // 못 물어봤으면 꺼진 것으로 둔다. 화면 동작을 막지 않는다
      }
    },
    // 진단 로그 — 화면 콘솔을 서버로 보낸다. 사용자에게 배너로 알린다(숨기지 않는다).
    // 확장 스위치도 여기서 같이 넘긴다 — 확장은 SSE 를 못 받는다.
    startDiagLog(until) {
      const untilMs = until ? new Date(until).getTime() : Date.now() + 3600000;
      if (this.diagUntil === untilMs) return;   // 같은 세션을 두 번 켜지 않는다
      this.diagUntil = untilMs;
      this.diagOn = true;

      window.postMessage({
        type: 'couplusDiagSet',
        on: true,
        until: new Date(untilMs).toISOString(),
        companyid: this.$store.state.user.companyid,
        suppliercode: this.$store.state.user.suppliercode
      }, '*');

      if (!this.diagOrigConsole) {
        this.diagOrigConsole = {};
        ['log', 'warn', 'error'].forEach((lv) => {
          this.diagOrigConsole[lv] = console[lv].bind(console);
          console[lv] = (...args) => {
            this.diagCapture(lv, args);
            this.diagOrigConsole[lv](...args);
          };
        });
      }
      if (!this.diagTimer) this.diagTimer = setInterval(this.diagFlush, 5000);
    },
    stopDiagLog() {
      this.diagOn = false;
      this.diagUntil = 0;
      this.diagBuf = [];
      if (this.diagTimer) { clearInterval(this.diagTimer); this.diagTimer = null; }
      if (this.diagOrigConsole) {
        ['log', 'warn', 'error'].forEach((lv) => { console[lv] = this.diagOrigConsole[lv]; });
        this.diagOrigConsole = null;
      }
      window.postMessage({ type: 'couplusDiagSet', on: false }, '*');
    },
    // 마스킹은 캡처 시점에 한다. 민감값이 서버에 아예 안 닿게 하는 게 목적이다
    diagMask(text) {
      return String(text == null ? '' : text).slice(0, 1000)
        .replace(/((?:pw|passwd|password)\s*["']?\s*[:=]\s*["']?)([^"',}\s]+)/gi, '$1***')
        .replace(/(Bearer\s+)[A-Za-z0-9._~+/=-]{8,}/gi, '$1***')
        .replace(/((?:accessToken|refreshToken|xsrfToken|token|secret|sessionKey|apiKey)\s*["']?\s*[:=]?\s*["']?)([A-Za-z0-9._~+/=-]{8,})/gi, '$1***');
    },
    diagCapture(level, args) {
      if (!this.diagOn || this.diagInCapture) return;
      if (this.diagUntil && Date.now() > this.diagUntil) { this.stopDiagLog(); return; }
      this.diagInCapture = true;
      try {
        const msg = args.map((v) => {
          if (typeof v === 'string') return v;
          if (v instanceof Error) return v.message;
          try { const o = JSON.stringify(v); return o === undefined ? String(v) : o; } catch (e) { return String(v); }
        }).join(' ');
        this.diagBuf.push({ t: new Date().toISOString().slice(11, 23), lv: level, m: this.diagMask(msg) });
        if (this.diagBuf.length > 1200) this.diagBuf.splice(0, this.diagBuf.length - 1200);
      } catch (e) {
        // 캡처가 화면을 망가뜨리면 안 된다. 여기서 console 을 부르면 재귀다
      }
      this.diagInCapture = false;
    },
    async diagFlush() {
      if (!this.diagOn || this.diagSending || this.diagBuf.length === 0) return;
      if (this.diagUntil && Date.now() > this.diagUntil) { this.stopDiagLog(); return; }
      this.diagSending = true;
      const batch = this.diagBuf;
      this.diagBuf = [];
      try {
        const res = await axios.post('/api/diag/report', {
          companyid: this.$store.state.user.companyid,
          suppliercode: this.$store.state.user.suppliercode,
          source: 'web',
          version: '',
          lines: batch
        });
        // 서버가 세션이 없다고 하면 스스로 멈춘다(만료됐거나 담당자가 껐다)
        if (res.data && res.data.success === false && res.data.on === false) this.stopDiagLog();
      } catch (e) {
        // 전송 실패분은 버린다. 다시 쌓으면 같은 실패가 반복되며 메모리만 먹는다
      }
      this.diagSending = false;
    },
    // SSE 연결 해제
    disconnectSSE() {
      const sseConnection = this.$store.state.sseConnection;
      if (sseConnection) {
        sseConnection.close();
        this.$store.commit('sseSetConnection', null);
        console.log('[SSE] 전역 연결 해제됨');
      }
    }
  }
}
</script>
<style>
</style>
